import React from "react";
import "./Style.css";

import { ToastContainer, toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// const ON_CHAIN_BTC_ADDR = "bc1q9j0r76vfnjyejarrx3634q9u937ymwlppc9pgt";
// const LNURL_BTC_ADDR =
// "LNURL1DP68GURN8GHJ7AMPD3KX2AR0VEEKZAR0WD5XJTNRDAKJ7TNHV4KXCTTTDEHHWM30D3H82UNVWQHHXAR0D93KSETVD4JHGVENUHSWDK";
const LIGHTNING_TIP_JAR = "facialanger53@walletofsatoshi.com";
const CONTACT_MAIL = "contact@inbtcterms.com";

const showToast = (text: string) => {
  const toastConfig: ToastOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    // progress: true,
  };

  toast(text, toastConfig);
};

const copyToClipboard = async (text: string, successMessage: string) => {
  try {
    if (window.isSecureContext && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      showToast(successMessage);
      return;
    }

    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    const copied = document.execCommand("copy");
    document.body.removeChild(textArea);

    if (copied) {
      showToast(successMessage);
      return;
    }
  } catch (err) {
    console.error("Copy failed", err);
  }

  showToast(`Copy manually: ${text}`);
};

const Footer = () => {
  const lightningLink = `lightning:${LIGHTNING_TIP_JAR}`;
  const mailtoLink = `mailto:${CONTACT_MAIL}`;

  return (
    <footer className="footer">
      <div className="content">
        <section className="footer-card">
          <h3 className="footer-heading">Lightning Tip Jar</h3>
          <p className="footer-text">
            Open in your Lightning wallet, or copy the address if nothing opens.
          </p>
          <a className="value-pill lightning-link" href={lightningLink}>
            {LIGHTNING_TIP_JAR}
          </a>
          <div className="actions">
            <a href={lightningLink} className="action-button primary">
              Open Lightning Wallet
            </a>
            <button
              type="button"
              className="action-button"
              onClick={() => copyToClipboard(LIGHTNING_TIP_JAR, "Lightning address copied")}
            >
              Copy Address
            </button>
          </div>
        </section>
        <section className="footer-card">
          <h3 className="footer-heading">Contact</h3>
          <p className="footer-text">Questions, feedback, or partnership ideas are welcome.</p>
          <a className="value-pill email-link" href={mailtoLink}>
            {CONTACT_MAIL}
          </a>
          <div className="actions">
            <a href={mailtoLink} className="action-button primary">
              Email Us
            </a>
            <button
              type="button"
              className="action-button"
              onClick={() => copyToClipboard(CONTACT_MAIL, "Contact email copied")}
            >
              Copy Email
            </button>
          </div>
        </section>
      </div>
      <ToastContainer />
    </footer>
  );
};

export default Footer;
